<template>
    <div class="btn-group">
        <Button size="sm" :disabled="disabled" color="light" data-toggle="dropdown">
            <i :class="[icon]"></i>
            <span v-if="title" class="ml-2">{{ title }}</span>
        </Button>
        <div class="dropdown-menu dropdown-menu-right">
            <slot name="menu"></slot>
        </div>
    </div>
</template>

<script>
import Button from "./new/button/AppButton.vue";
export default {
    name: 'DropdownComponent',
    components: {
        Button
    },
    props : {
        title: {
            type: String,
            default() {
                return null;
            }
        },
        icon: {
            type: String,
            default() {
                return 'icon-menu7';
            }
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            }
        },
    }
}
</script>
